import React, { Component } from 'react';
import { Grid, Row, Col } from 'react-flexbox-grid';
import { connect } from 'react-redux';
import RaisedButton from 'material-ui/RaisedButton';
import FlatButton from 'material-ui/FlatButton';
import {Card, CardActions, CardHeader, CardText} from 'material-ui/Card';
import ServiceCard from './ServiceCard';
import ActiveServiceCard from './ActiveServiceCard';

const ActiveServicesList = ({activeServices=[], color}) => <div>
    {activeServices.map(service => 
        <ActiveServiceCard key={service._id} service={service} color={color}/>
    )}
</div>;

const InactiveServicesList = ({serviceList=[], activeServices=[], color}) => <div>
    {serviceList.map(service => {
            if (activeServices.includes(service)) {
                return <ServiceCard key={service._id} service={service} color={color} disabled={true} />;
            } else {
                return <ServiceCard key={service._id} service={service} color={color}/>;
            }
        }
    )}
</div>;

const Dashboard = ({activeServices, maintanenceGroup, landscapingGroup, fertilizationGroup, pressureWashingGroup}) => 
    <Grid fluid>
        <h1 style={{textAlign: "center"}}>Account Management</h1>
        {
            activeServices &&         
            <div>
                <h2>Active Services</h2>
                <Row>
                    <Col xs={12} sm={4}>
                        <ActiveServicesList activeServices={activeServices} />
                    </Col>
                    <Col xs={12} sm={4}>
                        <ActiveServicesList serviceList={maintanenceGroup.col2} color="#A7C0C1" />
                    </Col>
                    <Col xs={12} sm={4}>
                        <ActiveServicesList serviceList={maintanenceGroup.col3} color="#A7C0C1" />
                    </Col>
                </Row>
            </div>
        }
        <h2>All Services and Referrals</h2>
        <h3>Lawncare Maintance</h3>
        <Row>
            <Col xs={12} sm={4}>
                <InactiveServicesList serviceList={maintanenceGroup.col1} activeServices={activeServices} color="#A7C0C1" />
            </Col>
            <Col xs={12} sm={4}>
                <InactiveServicesList serviceList={maintanenceGroup.col2} activeServices={activeServices} color="#A7C0C1" />
            </Col>
            <Col xs={12} sm={4}>
                <InactiveServicesList serviceList={maintanenceGroup.col3} activeServices={activeServices} color="#A7C0C1" />
            </Col>
        </Row>
        <h3>Landscaping</h3>
        <Row>
            <Col xs={12} sm={4}>
                <InactiveServicesList serviceList={landscapingGroup.col1} activeServices={activeServices} color="#DBE3D0" />
            </Col>
            <Col xs={12} sm={4}>
                <InactiveServicesList serviceList={landscapingGroup.col2} activeServices={activeServices} color="#DBE3D0" />
            </Col>
            <Col xs={12} sm={4}>
                <InactiveServicesList serviceList={landscapingGroup.col3} activeServices={activeServices} color="#DBE3D0" />
            </Col>
        </Row>
        <h3>Fertilization</h3>
        <Row>
            <Col xs={12} sm={4}>
                <InactiveServicesList serviceList={fertilizationGroup.col1} activeServices={activeServices} color="#DCE8E5" />
            </Col>
            <Col xs={12} sm={4}>
                <InactiveServicesList serviceList={fertilizationGroup.col2} activeServices={activeServices} color="#DCE8E5" />
            </Col>
            <Col xs={12} sm={4}>
                <InactiveServicesList serviceList={fertilizationGroup.col3} activeServices={activeServices} color="#DCE8E5" />
            </Col>
        </Row>
        <h3>Pressure Washing</h3>
        <Row>
            <Col xs={12} sm={4}>
                <InactiveServicesList serviceList={pressureWashingGroup.col1} activeServices={activeServices} color="#CBC8D7" />
            </Col>
            <Col xs={12} sm={4}>
                <InactiveServicesList serviceList={pressureWashingGroup.col2} activeServices={activeServices} color="#CBC8D7" />
            </Col>
            <Col xs={12} sm={4}>
                <InactiveServicesList serviceList={pressureWashingGroup.col3} activeServices={activeServices} color="#CBC8D7" />
            </Col>   
        </Row>
    </Grid>;

function createGroup(list, size) {
    if (list.length < size ) {
        return createGroup(list, list.length);
    }

    const i = Math.floor(list.length/size);

    return {
        col1: list.slice(0,i),
        col2: list.slice(i,i*2),
        col3: list.slice(i*2)
    };
}

function mapStateToProps({user, services: {   
    maintanenceServices, 
    landscapingServices, 
    fertilizationServices, 
    pressureWashingServices
    }}) {
    const maintanenceGroup = createGroup(maintanenceServices, 3),
        landscapingGroup = createGroup(landscapingServices, 3),
        fertilizationGroup = createGroup(fertilizationServices, 3),
        pressureWashingGroup = createGroup(pressureWashingServices, 3);

    const groups = {  maintanenceGroup, landscapingGroup, fertilizationGroup, pressureWashingGroup };
    if (user.services.length > 0) {
        return { activeServices: user.services, ...groups};
    }

    return { ...groups };
}

function mapDispatchToProps(dispatch) {
    return { };
}

export default connect(mapStateToProps, mapDispatchToProps)(Dashboard); 


// WEBPACK FOOTER //
// ./src/components/Dashboard.js